import React from "react";

interface AccountPeopleIconProps {
  color: string;
}

const AccountPeopleIcon = (props: AccountPeopleIconProps) => {
  const { color } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_141_1219)">
        <path
          d="M8.45455 6.61364C7.8 6.61364 6.78 6.79909 6 7.15909C5.22 6.79364 4.2 6.61364 3.54545 6.61364C2.36182 6.61364 0 7.20273 0 8.38636V9.88636H12V8.38636C12 7.20273 9.63818 6.61364 8.45455 6.61364ZM6.27273 9.06818H0.818182V8.38636C0.818182 8.09182 2.21455 7.43182 3.54545 7.43182C4.87636 7.43182 6.27273 8.09182 6.27273 8.38636V9.06818ZM11.1818 9.06818H7.09091V8.38636C7.09091 8.13545 6.98182 7.91727 6.80727 7.72091C7.28727 7.55727 7.87636 7.43182 8.45455 7.43182C9.78545 7.43182 11.1818 8.09182 11.1818 8.38636V9.06818ZM3.54545 6.06818C4.59818 6.06818 5.45455 5.21182 5.45455 4.15909C5.45455 3.10636 4.59818 2.25 3.54545 2.25C2.49273 2.25 1.63636 3.10636 1.63636 4.15909C1.63636 5.21182 2.49273 6.06818 3.54545 6.06818ZM3.54545 3.06818C4.14545 3.06818 4.63636 3.55909 4.63636 4.15909C4.63636 4.75909 4.14545 5.25 3.54545 5.25C2.94545 5.25 2.45455 4.75909 2.45455 4.15909C2.45455 3.55909 2.94545 3.06818 3.54545 3.06818ZM8.45455 6.06818C9.50727 6.06818 10.3636 5.21182 10.3636 4.15909C10.3636 3.10636 9.50727 2.25 8.45455 2.25C7.40182 2.25 6.54545 3.10636 6.54545 4.15909C6.54545 5.21182 7.40182 6.06818 8.45455 6.06818ZM8.45455 3.06818C9.05455 3.06818 9.54545 3.55909 9.54545 4.15909C9.54545 4.75909 9.05455 5.25 8.45455 5.25C7.85455 5.25 7.36364 4.75909 7.36364 4.15909C7.36364 3.55909 7.85455 3.06818 8.45455 3.06818Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_141_1219">
          <rect width="12" height="12" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AccountPeopleIcon;
